import NeedsAttentionDashboardView from './needs_attention_dashboard';

export {
  NeedsAttentionDashboardView
};
